<template>
  <Form
    ref="editCampaignForm"
    @updated="isUpdated"
    :edit-mode="true"></Form>
</template>

<script>
import Form from "@views/admin/emails/Campaigns/Form";

export default {
  name: "EditCampaign",
  components: {Form},
  props: ["campaignId"],
  async mounted() {
    this.startLoading();
    const {data} = await axios.get(`/api/app-http-services/services/notifications/email/campaigns/${this.campaignId}`)
    this.$refs.editCampaignForm.campaign = data;
    this.$refs.editCampaignForm.wantScheduleCampaign = data.schedule_date !== null;
    this.$refs.editCampaignForm.from = {
      email: data.from_email,
      name: data.from_name,
    };
    this.stopLoading();
  },
  methods: {
    isUpdated() {
      this.$emit("updated");
    }
  }
}
</script>